import React from 'react';
import { Col } from 'react-bootstrap';
import Button from '../../../../../components/button';
import { useNamespacedTranslation } from '../../../../../hooks/useNamespacedTranslation';
import ConfirmModal from '../../../../../components/Modal/ConfirmModal';

type CancelRequestActionCellProps = {
  requestId: string;
  requestToCancel: string | null;
  isCancelling: boolean;
  onCancelClick: (requestId: string) => void;
};

export const CancelRequestActionCell: React.FC<
  React.PropsWithChildren<CancelRequestActionCellProps>
> = ({ requestId, requestToCancel, isCancelling, onCancelClick }) => {
  const t = useNamespacedTranslation('schedulerShifts.shiftChangeRequest');

  const isThisRequest = requestToCancel === requestId;

  return (
    <Col className="col-auto">
      <Button
        label={t('cancelRequest')}
        isProcessing={isCancelling && isThisRequest}
        disabled={isCancelling}
        variant="outline-danger"
        size="sm"
        icon="close-outline"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onCancelClick(requestId);
        }}
      />
    </Col>
  );
};

type CancelRequestModalProps = {
  requestToCancel: string | null;
  isCancelling: boolean;
  onConfirm: () => Promise<void>;
  onClose: () => void;
};

export const CancelRequestModal: React.FC<
  React.PropsWithChildren<CancelRequestModalProps>
> = ({ requestToCancel, isCancelling, onConfirm, onClose }) => {
  const t = useNamespacedTranslation('schedulerShifts.shiftChangeRequest');

  return (
    <ConfirmModal
      show={!!requestToCancel}
      loading={isCancelling}
      title={t('cancelConfirmation.title')}
      text={t('cancelConfirmation.message')}
      onConfirm={onConfirm}
      onClose={onClose}
      yesLabel={t('cancelConfirmation.confirm')}
      noLabel={t('cancelConfirmation.cancel')}
    />
  );
};
